/**
 * INIT
 *
 * This function initializes all modules used on the site, try to keep it as
 * simple as possible moving any complicated logic into the modules itself
 */
const Init = function () {
	const MenuUSA = handleModule(import('./menu-usa'))

	window.DEHNUSA = {
		MenuUSA,
	}
}

Init()


function handleModule(module) {
	return module.then(handleModuleSuccess).catch(handleModuleError)
}

function handleModuleSuccess({ default: module }) {
	module.init()
}

function handleModuleError(error) {
	console.error(error)
}
